import React from 'react';
import { useBanners } from '../../../context/banners';

export const useBanner = (bannerId: string | null) => {
  const { allBanners, findBannerById } = useBanners();

  return React.useMemo(() => {
    if (!bannerId) return null;
    // El registro cubre todas las páginas cargadas (dashboard + library paginado);
    // allBanners queda como fallback por si el banner solo vive ahí.
    return findBannerById(bannerId) ?? allBanners.find(banner => banner.bannerId === bannerId) ?? null;
  }, [allBanners, findBannerById, bannerId]);
};
